import React from "react";
import Radios from "@radarly/components/panels/card-edition/sidebar/radios";
import { DatavizHorizontalBarChart } from "@radarly/models/dataviz";
import { useNullValues } from "./model";

export interface NullValuesProps {
  dataviz: DatavizHorizontalBarChart;
  setDataviz: (dataviz: DatavizHorizontalBarChart) => void;
}

export default function NullValues({ dataviz, setDataviz }: NullValuesProps) {
  const { label, options, option, onChange } = useNullValues(
    dataviz,
    setDataviz
  );
  return (
    <Radios
      label={label}
      value={option}
      options={options}
      onChange={onChange}
    />
  );
}
